export const Questions = [
  {
    id: '1',
    question: 'Question1',
    answer: 'Answer1',
    link: 'https://insurancemarket.ae/yachtpolicies/',
  },
];

export const Promises = [
  {
    icon: '/assets/img/yacht/promise/icon1.png',
    text: 'PromiseText1',
  },
  {
    icon: '/assets/img/yacht/promise/icon2.png',
    text: 'PromiseText2',
  },
  {
    icon: '/assets/img/yacht/promise/icon3.png',
    text: 'PromiseText3',
  },
  {
    icon: '/assets/img/yacht/promise/icon4.png',
    text: 'PromiseText4',
  },
];

export const Benefits = [
  {
    icon: '/assets/img/yacht/benefits/Water_skiers-1.svg',
    title: 'BenefitTitle1',
    text: 'BenefitDetail1',
  },
  {
    icon: '/assets/img/yacht/benefits/Cruising_range_extension.svg',
    title: 'BenefitTitle2',
    text: 'BenefitDetail2',
  },
  {
    icon: '/assets/img/yacht/benefits/Racing-risks.svg',
    title: 'BenefitTitle3',
    text: 'BenefitDetail3',
  },
  {
    icon: '/assets/img/yacht/benefits/Personalaccident.svg',
    title: 'BenefitTitle4',
    text: 'BenefitDetail4',
  },
  {
    icon: '/assets/img/yacht/benefits/Personal_effects.svg',
    title: 'BenefitTitle5',
    text: 'BenefitDetail5',
  },
  {
    icon: '/assets/img/yacht/benefits/search_rescue.svg',
    title: 'BenefitTitle6',
    text: 'BenefitDetail6',
  },
];

export const EasySteps = [
  {
    icon: '/assets/img/yacht/easysteps/icon1.png',
    text: 'EasyStepText1',
  },
  {
    icon: '/assets/img/yacht/easysteps/icon2.png',
    text: 'EasyStepText2',
  },
  {
    icon: '/assets/img/yacht/easysteps/icon3.png',
    text: 'EasyStepText3',
  },
];

export const PleasureCrafts = [
  {
    icon: '/assets/img/yacht/pleasurecrafts/Hull-and-Machinery.svg',
    title: 'hullnMachinery',
    text: 'coversTheLoss',
  },
  {
    icon: '/assets/img/yacht/pleasurecrafts/Third-party-liability.svg',
    title: 'thirdPartyLiability',
    text: 'coversYouAgainst',
  },
  {
    icon: '/assets/img/yacht/pleasurecrafts/Uninsured-Boater.svg',
    title: 'unInsuredBoater',
    text: 'coversYouAndGuests',
  },
  {
    icon: '/assets/img/yacht/pleasurecrafts/Personal-Effects.svg',
    title: 'personalEffects',
    text: 'isAnOptional',
  },
  {
    icon: '/assets/img/yacht/pleasurecrafts/Search-and-Rescue-Services.svg',
    title: 'searchAndRescue',
    text: 'coversExpenses',
  },
  {
    icon: '/assets/img/yacht/pleasurecrafts/Racing-Risk-Coverage.svg',
    title: 'racingRiskCoverage',
    text: 'itIsAPolicyExtension',
  },
];

export const Partners = [
  {
    icon: '/assets/img/yacht/partners/axa-logo.png',
    title: 'Hull and Machinery',
  },
  {
    icon: '/assets/img/yacht/partners/alsagr-logo.png',
    title: 'Third Party Liability',
  },
  {
    icon: '/assets/img/yacht/partners/takaful-logo.png',
    title: 'Uninsured Boater',
  },
  {
    icon: '/assets/img/yacht/partners/bupa-logo.png',
    title: 'Personal Effects',
  },
  {
    icon: '/assets/img/yacht/partners/orient-logo.png',
    title: 'Search and Rescue Services',
  },
  {
    icon: '/assets/img/yacht/partners/qic-logo.png',
    title: 'Racing Risk Coverage',
  },
];

export const GoogleReviews = [
  {
    id: '1',
    avatar: '/assets/img/yacht/reviews/client-1.png',
    name: 'Delna Prakashan',
    reviewText:
      'This is perhaps my 4th year working with Insurance market. They are extremely prompt in their response and very efficient to guide you with insurance plans. I certainly appreciate the auto-reminders they have in place which makes it easy for a client to keep track of their renewals. Will certainly recommend anyone to purchase their insurance via Insurance Market as you can be guaranteed of the best prices in the market.',
  },
  {
    id: '2',
    avatar: '/assets/img/yacht/reviews/client-2.png',
    name: 'Dilu Pillai',
    reviewText:
      'This is my second time I have associated with AFIA for insurance. As usual they did an amazing job in getting me the perfect insurance coverage the market has to offer. Prompt service that focuses on customer satisfaction. Highly recommended. Cheers! Keep up the good work team.',
  },
  {
    id: '3',
    avatar: '/assets/img/yacht/reviews/client-3.png',
    name: 'Baseer Hassan',
    reviewText:
      'After checking with almost every broker in UAE, i found the rate, service and quality at insurancemarket,ae the best. The agent was super quick and had replied for all my queries promptly. So far the experience has been fantastic. Would approach them(him) again for all insurance related needs.',
  },
  {
    id: '4',
    avatar: '/assets/img/yacht/reviews/client-4.png',
    name: 'Antoun Ghosn',
    reviewText:
      'Excellent Experience and all is great! The most important factor is that they are honest! Always replying and assisting immediately. They gave me 3 options, of which I chose what suits my requirement. Not only that, they also assisted once I needed an insurance claim and connected me directly with the insurance within 24 hours. Their superstar is Vijay, superb insurance advisor! Highly recommended!',
  },
  {
    id: '5',
    avatar: '/assets/img/yacht/reviews/client-5.png',
    name: 'Irnesa Hodzic',
    reviewText:
      'Evan was very diligent and quick to respond to my queries. He advised me well and I was able to make the right insurance purchase for my trip abroad.',
  },
  {
    id: '6',
    avatar: '/assets/img/yacht/reviews/client-6.png',
    name: 'Raed Alkhatib',
    reviewText:
      'It has been an amazing experience with AFIA, a gentleman Bret Tulang assisted me in finding the cheapest health insurance policy with an amazing medical coverage network. It is highly recommended and Im looking forward to keep in touch for any insurance relevant matter.',
  },
  {
    id: '11',
    avatar: '/assets/img/yacht/reviews/client-11.png',
    name: 'Rhuddhesh Kirtikar',
    reviewText:
      'My regular go to guys for all travel insurance related services. Initially Sean and then Evan. They are extremely helpful, quick and efficient. Keep up the good work.',
  },
  // {
  //   id: '7',
  //   avatar: '/assets/img/yacht/reviews/client-7.png',
  //   name: 'Carolina Williams',
  //   reviewText:
  //     'Exceptional customer service and turnaround time. The Personal Shopper was always on top of every aspect of my car insurance and it was the easiest and most efficient experience I’ve had with insuring my car. Would highly recommend using Insurance Market.',
  // },
  // {
  //   id: '8',
  //   avatar: '/assets/img/yacht/reviews/client-8.png',
  //   name: 'James Poole',
  //   reviewText:
  //     'Great service! Very helpful representative Akshae Golekar, polite to speak to & saved me a good amount of money without me needing to call around numerous brokers!',
  // },
  // {
  //   id: '9',
  //   avatar: '/assets/img/yacht/reviews/client-9.png',
  //   name: 'Mohamed Miligi',
  //   reviewText:
  //     'Very good service and quick response, I got my car insurance from them, recommend anyone looking for insurance to contact them. They will give the best deal.',
  // },
  // {
  //   id: '10',
  //   avatar: '/assets/img/yacht/reviews/client-10.png',
  //   name: 'Aman Marya',
  //   reviewText:
  //     'One stop shop to decide on which insurance to chose. I got exactly what I needed and in time. Really happy that I reached out to Hero from Insurance Market. He was professional and very helpful and worked out the options based on my requirement. I would highly recommend trying them out before you reach out to anyone else.',
  // },
  // {
  //   id: '11',
  //   avatar: '/assets/img/yacht/reviews/client-11.png',
  //   name: 'Rhuddhesh Kirtikar',
  //   reviewText:
  //     'My regular go to guys for all travel insurance related services. Initially Sean and then Evan. They are extremely helpful, quick and efficient. Keep up the good work.',
  // },
];
